import { Validators } from '@angular/forms';
import { FormGroup } from '@shared/modules/form/interfaces';

export const getLoginFormBuilder: FormGroup = ({
  controls: {
    email: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required]
  }
});
